import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Popover,
  Table,
  TableBody,
  TableCell,
  Select,
  ListItemText,
  MenuItem,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  Snackbar,
  Alert
} from '@mui/material';
import { useEffect, useState, useCallback } from 'react';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import EditIcon from '@mui/icons-material/Edit';
import useApi from 'hooks/useApi';
import useSelection from 'hooks/useSelection';
import SearchIcon from '@mui/icons-material/Search';
import { DateRangePicker } from 'mui-daterange-picker';
import DateRangeIcon from '@mui/icons-material/DateRange';
import { parse, format, isValid } from 'date-fns';
import { debounce } from 'lodash';
import MainCard from 'components/MainCard';
import { formatDateWithTimezoneDisplay } from 'utils/dateFormat';

const UnmappedTransactionsData = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [mappedActions, setMappedActions] = useState<HTMLButtonElement | null>(null);
  const [transactionData, setTransactionData] = useState<any>({});
  const [openRange, setOpenRange] = useState(false);
  const [dateRange, setDateRange] = useState<any>({ startDate: null, endDate: null });
  const [searchText, setSearchText] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [eventTypes, setEventTypes] = useState<any>(['IMAGE', 'VIDEO', 'SESSION', 'SIGN', 'LOCATION']);
  const [alert, setAlert] = useState<any>({
    open: false,
    severity: 'success',
    message: ''
  });
  const [UnmappedKeyId, setUnmappedKeyId] = useState<string>('');
  const [eventStatus, setEventStatus] = useState<any>([
    'UPLOADED',
    'CALLING',
    'RECEIVED',
    'IN_PROGRESS',
    'MISSED_CALL',
    'MANUAL_DISCONNECT',
    'COMPLETED'
  ]);
  //   const teamOptions: any = [];
  const [teamOptions, setTeamOptions] = useState<string[]>([]);
  const [selectedClient, setSelectedClient] = useState<string>('');
  const [selectedTeams, setSelectedTeams] = useState<string>('');
  const [mainTag, setMainTag] = useState<string[]>([]);
  const [subTag, setSubTag] = useState<string[]>([]);

  const { getUnmappedTransaction, getTeamByClient, mapKeyToTeam } = useApi();
  const { clientOptions } = useSelection();
  const today = new Date();
  const formatDate = (date: Date | null) => {
    return date ? format(date, 'dd/MM/yyyy') : '';
  };

  const [inputValues, setInputValues] = useState({
    startDate: formatDate(today),
    endDate: formatDate(today)
  });

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMapDataClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMappedActions(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleMappedClose = () => {
    setMappedActions(null);
  };
  const open = Boolean(anchorEl);
  const openActions = Boolean(mappedActions);
  const id = open ? 'simple-popover' : undefined;

  const getTransactions = async () => {
    try {
      setLoading(true);
      const payload = {
        page: page + 1,
        size: rowsPerPage,
        search: searchText,
        from: dateRange.startDate ? format(dateRange.startDate, 'dd-MM-yyyy') : '',
        to: dateRange.endDate ? format(dateRange.endDate, 'dd-MM-yyyy') : '',
        eventTypes,
        eventStatus,
        teams: [],
        users: [],
        mainTag,
        subTag
      };

      const data = await getUnmappedTransaction(payload);
      const { success, data: transData } = data;
      if (success) {
        setTransactionData(transData);
      }
    } catch (error) {
      console.error('Error fetching transactions:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTransactions();
  }, [page, rowsPerPage, dateRange, searchText]);

  const loadsTeams = async (selectedClient: string) => {
    if (selectedClient) {
      let tagsResp = await getTeamByClient(selectedClient);

      let { success, data } = tagsResp;
      if (success) {
        //   setClientOptions(data);
        setTeamOptions(data);
      }
    }
  };

  useEffect(() => {
    loadsTeams(selectedClient);
  }, [selectedClient]);

  const handleChangePage = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const mapTransactionDetails = async () => {
    if (!selectedTeams && !UnmappedKeyId) {
      setAlert({
        open: true,
        severity: 'error',
        message: 'Please Select a Team and Client'
      });
      return;
    }
    if (!selectedTeams) {
      setAlert({
        open: true,
        severity: 'error',
        message: 'Please Select a Team'
      });
      return;
    }

    if (!UnmappedKeyId) {
      setAlert({
        open: true,
        severity: 'error',
        message: 'Please Select a Client'
      });
      return;
    }
    const payload = {
      team: selectedTeams,
      key: UnmappedKeyId
    };

    try {
      const tagsResp = await mapKeyToTeam(payload);
      const { success, message } = tagsResp;

      if (success) {
        setAlert({
          open: true,
          severity: 'success',
          message: message
        });
      } else {
        setAlert({
          open: true,
          severity: 'error',
          message: message
        });
      }
    } catch (error) {
      setAlert({
        open: true,
        severity: 'error',
        message: 'An unexpected error occurred.'
      });
    }
  };

  const toggle = () => setOpenRange(!openRange);
  const selectKeyId = (data: any) => {
    const uid = data?.keyId?.uid;
    if (uid) {
      setUnmappedKeyId(uid);
    } else {
      console.warn('UID is missing in row:', data);
    }
  };
  const handleInputChange = (key: 'startDate' | 'endDate', value: string) => {
    setInputValues((prev) => ({ ...prev, [key]: value }));

    const parsed = parse(value, 'dd/MM/yyyy', new Date());

    if (isValid(parsed)) {
      setDateRange((prev: any) => ({ ...prev, [key]: parsed }));
    }
  };

  const handleDateRangeChange = (range: any) => {
    setDateRange(range);
    setInputValues({
      startDate: formatDate(range.startDate),
      endDate: formatDate(range.endDate)
    });
  };

  const handleSearch = useCallback(
    debounce((query: string) => {
      setSearchText(query);
      setPage(0);
    }, 1000),
    []
  );

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
    handleSearch(e.target.value);
  };

  const handleApplyFilter = () => {
    setPage(0);
    handleClose();
    getTransactions();
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = event.target;
    setEventTypes((prev: any[]) => (checked ? [...prev, value] : prev.filter((item: string) => item !== value)));
  };

  const handleEventStatusChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = event.target;
    setEventStatus((prev: any[]) => (checked ? [...prev, value] : prev.filter((item: string) => item !== value)));
  };

  const handleResetFilter = () => {
    setMainTag([]);
    setSubTag([]);
    setEventTypes(['IMAGE', 'VIDEO', 'SESSION', 'SIGN', 'LOCATION']);
    setEventStatus(['UPLOADED', 'CALLING', 'RECEIVED', 'IN_PROGRESS', 'MISSED_CALL', 'MANUAL_DISCONNECT', 'COMPLETED']);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box py={2}>
        {' '}
        <Divider />{' '}
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, flexWrap: 'wrap', gap: 2 }}>
        <Typography variant="h4" fontWeight={600}>
          {' '}
          Unmapped Transactions{' '}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
            <TextField
              label="Start Date"
              value={inputValues.startDate}
              onChange={(e) => handleInputChange('startDate', e.target.value)}
              size="small"
              placeholder="DD-MM-YYYY"
              inputProps={{ readOnly: true }}
            />
            <TextField
              label="End Date"
              value={inputValues.endDate}
              onChange={(e) => handleInputChange('endDate', e.target.value)}
              size="small"
              placeholder="DD-MM-YYYY"
              inputProps={{ readOnly: true }}
            />
            <IconButton onClick={toggle} size="medium" color="primary">
              {' '}
              <DateRangeIcon />{' '}
            </IconButton>
            {openRange && (
              <Box sx={{ position: 'absolute', zIndex: 10, top: '40px' }}>
                <DateRangePicker open={openRange} toggle={toggle} onChange={handleDateRangeChange} initialDateRange={dateRange} />
              </Box>
            )}
          </Box>

          <TextField
            variant="outlined"
            size="small"
            placeholder="Search..."
            value={searchText}
            onChange={handleSearchChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  {' '}
                  <SearchIcon />{' '}
                </InputAdornment>
              )
            }}
          />
          <Button variant="outlined" color="primary" startIcon={<FilterAltIcon />} onClick={handleClick}>
            {' '}
            Filters
          </Button>
        </Box>
      </Box>
      <MainCard>
        <Box sx={{ overflowX: 'hidden' }}>
          <Table stickyHeader sx={{ tableLayout: 'fixed', width: '100%', paddingRight: '20px' }}>
            <TableHead>
              <TableRow>
                <TableCell style={{ width: '25%' }}>Details</TableCell>
                <TableCell style={{ width: '25%' }}>Time / Location</TableCell>
                <TableCell style={{ width: '20%' }}>Participants</TableCell>
                <TableCell style={{ width: '25%' }}>Info</TableCell>
                <TableCell style={{ width: '5%' }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    <CircularProgress size={24} />
                  </TableCell>
                </TableRow>
              ) : transactionData?.rows?.length > 0 ? (
                transactionData?.rows?.map((row: any, index: number) => (
                  <TableRow key={index}>
                    <TableCell style={{ width: '25%' }}>
                      <Typography variant="body2">
                        <strong>Transaction Id:</strong> {row.key}
                      </Typography>
                      <Typography variant="body2">
                        <strong>Client:</strong> {row?.client?.name}
                      </Typography>
                      <Typography variant="body2">
                        <strong>Team:</strong> {row?.team?.name}
                      </Typography>
                    </TableCell>
                    <TableCell style={{ width: '25%' }}>
                      <Typography variant="body2">
                        <strong>Time:</strong> {row?.createdAt ? formatDateWithTimezoneDisplay(row.createdAt) : ''}
                      </Typography>
                      <Typography variant="body2">
                        <strong>Location:</strong> {row?.location?.location}
                      </Typography>
                    </TableCell>
                    <TableCell style={{ width: '20%' }}>
                      <Typography variant="body2">
                        <strong>Caller:</strong> {row?.userName}
                      </Typography>
                    </TableCell>
                    <TableCell style={{ width: '25%' }}>
                      <Typography variant="body2">
                        <strong>Type:</strong> {row?.eventType}
                      </Typography>
                      <Typography variant="body2">
                        <strong>Status:</strong>{' '}
                        <span
                          style={{
                            color:
                              row?.eventStatus === 'COMPLETED'
                                ? 'green'
                                : row?.eventStatus === 'MISSED_CALL'
                                ? 'red'
                                : row?.eventStatus === 'CALLING'
                                ? 'skyblue'
                                : row?.eventStatus === 'RECEIVED'
                                ? 'blue'
                                : row?.eventStatus === 'MANUAL_DISCONNECT'
                                ? 'hotpink'
                                : row?.eventStatus === 'IN_PROGRESS'
                                ? 'orange'
                                : 'inherit'
                          }}
                        >
                          {' '}
                          {row?.eventStatus}{' '}
                        </span>
                      </Typography>
                    </TableCell>
                    <TableCell style={{ width: '5%' }}>
                      <IconButton
                        color="primary"
                        onClick={(event) => {
                          handleMapDataClick(event);
                          selectKeyId(row);
                        }}
                      >
                        {/* <VisibilityIcon /> */}
                        <EditIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  {' '}
                  <TableCell colSpan={5} align="center">
                    {' '}
                    No data found.
                  </TableCell>{' '}
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>
      </MainCard>

      <TablePagination
        component="div"
        count={transactionData?.count || 0}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={{ top: window.innerHeight / 2, left: window.innerWidth / 2 }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'center'
        }}
        slotProps={{
          paper: {
            sx: {
              width: 500,
              p: 2
            }
          }
        }}
      >
        <Box sx={{ p: 2, minWidth: 200 }}>
          <Typography variant="h5">Filter By</Typography>

          <Box>
            <Box mb={1} mt={2}>
              <strong>Include Types:</strong>
            </Box>
            <Grid container spacing={2} marginLeft={0}>
              <FormControlLabel
                control={<Checkbox value="IMAGE" checked={eventTypes.includes('IMAGE')} onChange={handleCheckboxChange} />}
                label="Images"
              />
              <FormControlLabel
                control={<Checkbox value="VIDEO" checked={eventTypes.includes('VIDEO')} onChange={handleCheckboxChange} />}
                label="Videos"
              />
              <FormControlLabel
                control={<Checkbox value="SESSION" checked={eventTypes.includes('SESSION')} onChange={handleCheckboxChange} />}
                label="Sessions"
              />
              <FormControlLabel
                control={<Checkbox value="SIGN" checked={eventTypes.includes('SIGN')} onChange={handleCheckboxChange} />}
                label="Signs"
              />
              <FormControlLabel
                control={<Checkbox value="LOCATION" checked={eventTypes.includes('LOCATION')} onChange={handleCheckboxChange} />}
                label="Locations"
              />
            </Grid>

            <Box mb={1} mt={2}>
              <strong>Include Status:</strong>
            </Box>
            <Grid container spacing={2} marginLeft={0}>
              <FormControlLabel
                control={<Checkbox value="UPLOADED" checked={eventStatus.includes('UPLOADED')} onChange={handleEventStatusChange} />}
                label="Uploading"
              />
              <FormControlLabel
                control={<Checkbox value="CALLING" checked={eventStatus.includes('CALLING')} onChange={handleEventStatusChange} />}
                label="Calling"
              />
              <FormControlLabel
                control={<Checkbox value="RECEIVED" checked={eventStatus.includes('RECEIVED')} onChange={handleEventStatusChange} />}
                label="Received"
              />
              <FormControlLabel
                control={<Checkbox value="IN_PROGRESS" checked={eventStatus.includes('IN_PROGRESS')} onChange={handleEventStatusChange} />}
                label="Inprogress"
              />
              <FormControlLabel
                control={<Checkbox value="MISSED_CALL" checked={eventStatus.includes('MISSED_CALL')} onChange={handleEventStatusChange} />}
                label="Missed Calls"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    value="MANUAL_DISCONNECT"
                    checked={eventStatus.includes('MANUAL_DISCONNECT')}
                    onChange={handleEventStatusChange}
                  />
                }
                label="Manual Disconnect"
              />
              <FormControlLabel
                control={<Checkbox value="COMPLETED" checked={eventStatus.includes('COMPLETED')} onChange={handleEventStatusChange} />}
                label="Completed"
              />
            </Grid>
          </Box>

          <Box display="flex" justifyContent="flex-end" gap={1} mt={1}>
            <Button variant="text" color="secondary" onClick={handleResetFilter}>
              Reset Filter
            </Button>
            <Button variant="contained" color="primary" onClick={handleApplyFilter}>
              Apply Filter
            </Button>
            <Button variant="outlined" onClick={handleClose}>
              Close
            </Button>
          </Box>
        </Box>
      </Popover>

      <Popover
        id={id}
        open={openActions}
        anchorEl={mappedActions}
        onClose={handleMappedClose}
        anchorReference="anchorPosition"
        anchorPosition={{ top: window.innerHeight / 2, left: window.innerWidth / 2 }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'center'
        }}
        slotProps={{
          paper: {
            sx: {
              width: 500,
              p: 2
            }
          }
        }}
      >
        <Box>
          <Typography variant="h4">Transaction Mapping</Typography>
        </Box>
        <Box display="flex" flexDirection="row" gap={1} mt={2}>
          <Box sx={{ width: 200 }}>
            <Typography variant="h6" gutterBottom>
              Clients
            </Typography>
            <Select
              labelId="team-select-label"
              size="small"
              fullWidth
              value={selectedClient}
              onChange={(e) => setSelectedClient(e.target.value)}
              sx={{
                height: 40,
                display: 'flex',
                alignItems: 'center',
                '& .MuiSelect-select': {
                  display: 'flex',
                  alignItems: 'center',
                  height: '100%'
                }
              }}
            >
              {clientOptions?.map((client: any) => (
                <MenuItem key={client.uid} value={client.uid}>
                  <ListItemText primary={client.name} />
                </MenuItem>
              ))}
            </Select>
          </Box>

          <Box sx={{ width: 200 }}>
            <Typography variant="h6" gutterBottom>
              Teams
            </Typography>
            <Select
              labelId="team-select-label"
              size="small"
              fullWidth
              value={selectedTeams}
              onChange={(e) => setSelectedTeams(e.target.value)}
              sx={{
                height: 40, // adjust to match your design
                display: 'flex',
                alignItems: 'center',
                '& .MuiSelect-select': {
                  display: 'flex',
                  alignItems: 'center',
                  height: '100%'
                }
              }}
            >
              {teamOptions?.map((team: any) => (
                <MenuItem key={team.uid} value={team.uid}>
                  <ListItemText primary={team.name} />
                </MenuItem>
              ))}
            </Select>
          </Box>
        </Box>
        <Box display="flex" justifyContent="flex-end" gap={3} mt={1}>
          <Button variant="contained" color="primary" sx={{ width: 100 }} onClick={mapTransactionDetails}>
            Save
          </Button>
        </Box>
      </Popover>

      <Snackbar
        open={alert.open}
        autoHideDuration={4000}
        onClose={() => setAlert({ ...alert, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setAlert({ ...alert, open: false })} severity={alert.severity as 'success' | 'error'} sx={{ width: '100%' }}>
          {alert.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default UnmappedTransactionsData;
